module.exports = __webpack_public_path__ + "img/lock@2x.2d06f430.png";